// extracted by mini-css-extract-plugin
export default {"calculations":"f2NGhUFEGAKnkxtEuskq","total":"uTePGQ_C1dilGPWe9w6O","values":"GQgYtl1Je32bRSLCHqyn"};